import { Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root',
})
export class CreateAccountService {
  public accountCreator: string = null
  public nativeAuthToken: string = null
  public createdAccountId: string = null
  public entitlementToken: string = null
}
